<template>
  <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
    <FormItem label="账号" prop="account">
      <Input type="text" :placeholder="accrule" v-model="formCustom.account" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem label="密码" prop="passwd">
      <Input type="password" :placeholder="pwdrule" v-model="formCustom.passwd" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem label="密码确认" prop="passwdCheck">
      <Input type="password" v-model="formCustom.passwdCheck" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem>
      <Alert>
        特别提示
        <template slot="desc">
          <p>注册成功后,请及时关注微信公众号“众智云擎税法检索”,点击“云擎中心”按钮进入“文件提醒”绑定账号,即时精准获取税法文件智能推送。 </p>
        </template>
      </Alert>
    </FormItem>
    <!--    <FormItem label="用户协议" prop="agreement">
      <div style="margin-right: 140px;">
        <Checkbox v-model="formCustom.agreement">我同意并遵守</Checkbox><a @click="userAgreement">《用户协议》</a>
      </div>
    </FormItem> -->
  </Form>
</template>
<script>
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
//已通过短信码验证后,填写注册信息
export default {
  name: 'UserRegSetPassword',
  data() {
    const validateAccount = (rule, value, callback) => {
      console.log("validateAccount...")
      console.log(rule, value, this.formCustom.account)
      if (value === '') {
        callback(new Error('请输入账号'));
      } else {
        if (value.length > 12) {
        callback(new Error(this.accrule));
      }
        if (this.checkAcc(value)) {
          //账号远端有效性校验
          regJ.reqCheckUserId('', value).then(res => {
            console.log(res)
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                if (res.enabled) {
                  callback()
                } else {
                  callback(new Error(res.recommend));
                }
              } else {
                //特殊处理下提示信息,检测账号是否重复
                if(res.rltcode===-1){
                  callback(new Error(this.existDesc));
                }else{
                  callback(new Error(res.rltdesc));
                }
              }
            } else {
              callback(new Error(res.rtndesc));
            }
          })

        } else {
          callback(new Error(this.accrule));
        }
      }
    };

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formCustom.passwdCheck !== '') {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField('passwdCheck');
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error(this.pwdrule));
      }

      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value !== this.formCustom.passwd) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    };
    // const validateAgreement = (rule, value, callback) => {
    //   console.log('validateAgreement:'+value)
    //   if (value===false) {
    //     callback(new Error('请同意协议并提交注册'));
    //   }else{
    //     callback();
    //   }
    // };

    return {
      formCustom: {
        account: '',
        passwd: '',
        passwdCheck: '',
        agreement: true,
      },
      ruleCustom: {
        account: [
          { required: true, validator: validateAccount, trigger: 'blur' }
        ],
        passwd: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        passwdCheck: [
          { required: true, validator: validatePassCheck, trigger: 'blur' }
        ],
        // agreement: [
        //   { required: true, type:'boolean',validator: validateAgreement, trigger: 'change' }
        // ],
      },
      showtips: false,
      accrule: '账号只能使用数字或字母,长度不超过12位',
      pwdrule: '密码长度至少6位',
      existDesc:'该账号名已被注册，请重新设置',

    }
  },
  methods: {
    setAgreement() {
      this.formCustom.agreement = true
    },
    userAgreement() {
      this.$emit('show-agreement')
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.showtips = false;
          console.log(this.formCustom)
          this.$emit('regSetPwdOk', this.formCustom);
          //this.$Message.success('注册成功!');
          //ajax 成功则关闭,并跳转至登录

          //console.log(this.formCustom);
        } else {
          //this.$Message.error('Fail!');
          this.showtips = true;
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
      // console.log('reg-set-password clear')
      // this.formCustom.account=''
      // this.formCustom.passwd=''
      // this.formCustom.passwdCheck=''
      this.showtips = false;
    },
    checkAcc(txt) {
      if (!(/^[0-9a-zA-Z]{1,}$/.test(txt))) {
        return false;
      } else {
        return true;
      }
    },

  },
  created() {
    console.log('clear reg-set-password')
    this.formCustom.account = ''
    this.formCustom.passwd = ''
    this.formCustom.passwdCheck = ''
  }

}

</script>
<style>
</style>
